import React from "react";
import FormBuilder from "../../components/form/FormBuilder";
import withForm from "../../components/form/withForm";
import { Row, Col, Button, Alert } from "reactstrap";
import { ArrowRight } from 'react-bootstrap-icons';
import { IDispatchAuthLogin, authLogin, authClearError, IDispatchAuthClearError } from "../../redux/auth/actions";
import { connect } from "react-redux";
import { IReduxState } from "../../redux/types";
import Loading from "../../components/Loading";
import { ErrorReason } from "../../redux/auth/reducers";
import authenticationStore from "../../redux/auth/authenticationStore";
import { Link } from "react-router-dom";

interface ILoginData {
    username: string;
    password: string;
    rememberMe: boolean;
}

const builder = new FormBuilder<ILoginData>();
const definition = {
    username: builder.for('username', 'E-mailadres').text('text', (opt) => opt.required().length(3, 255).formatEmail()),
    password: builder.for('password', 'Wachtwoord').text('password', opt => opt.required().length(null, 255)),
    rememberMe: builder.for('rememberMe', 'Login onthouden').checkbox()
};

const LoginForm = withForm({ definition, initial: {} as ILoginData, validationMessages: 'hide' },
    ({ save, DynamicControl }) => <>
        <DynamicControl field={definition.username} />
        <DynamicControl field={definition.password} />
        <Row>
            <Col className="login-checkbox"><DynamicControl field={definition.rememberMe} /></Col>
            <Col>
                <Link to="/auth/recover"><p className="forgot-password text-right">Wachtwoord vergeten?</p></Link>
            </Col>
        </Row>

        <Button type="submit" className="btn-default-text" color="default" onClick={() => save()}>
            Log in<ArrowRight color="#1F4464" size={40} />
        </Button>
    </>
);

interface IReduxProps {
    attemptsRemaining: number;
    authStatus: 'idle' | 'busy' | 'error';
    authError: ErrorReason;
}
interface IReduxDispatch extends
    IDispatchAuthLogin,
    IDispatchAuthClearError {
}
interface IProps extends IReduxProps, IReduxDispatch { }

class Login extends React.Component<IProps> {
    public componentDidMount()
    {
        this.props.authClearError();
    } 

    private submit(data: ILoginData): Promise<boolean> {
        this.props.authLogin({ username: data.username, password: data.password, remember: data.rememberMe, isFromPrompt: true });

        return Promise.resolve(false);
    }
    private getErrorMessage(): string {
        switch (this.props.authError) {
            case 'InvalidCredential':
                return 'De opgegeven gebruikersnaam-wachtwoordcombinatie is ongeldig';
            case 'AttemptsExceeded':
                return 'Het opgegeven account is tijdelijk geblokkeerd';
            default:
                return 'Er is een fout opgetreden tijdens het inloggen';
        }
    }

    public render() {
        return <>
            {this.props.authStatus === 'busy' && <Loading />}
            {this.props.authStatus === 'error' && <Alert color="danger">
                {this.getErrorMessage()}
            </Alert>}

            {this.props.attemptsRemaining > 0 && this.props.attemptsRemaining <= 2 &&
                <Alert color="info"> 
                    {this.props.attemptsRemaining > 1 ? <span>Er zijn nog {this.props.attemptsRemaining} pogingen </span> : <span>Er is nog 1 poging </span>}
                over voor het account geblokkeerd wordt.
            </Alert>}

            <LoginForm
                disableOnSave={true}
                submit={(data) => this.submit(data)}
                load={() => Promise.resolve({ username: authenticationStore.cachedUsername || '', rememberMe: !!authenticationStore.cachedUsername, password: '' })}
            />
        </>;
    }
}
export default connect<IReduxProps, IReduxDispatch, IProps, IReduxState>(
    (state) => ({
        attemptsRemaining: state.auth.attemptsRemaining,
        authStatus: state.auth.status,
        authError: state.auth.errorReason
    }),
    {
        authLogin,
        authClearError
    },
)(Login);